import { render, staticRenderFns } from "./ItemVariationSelection.vue?vue&type=template&id=81da073e&scoped=true"
import script from "./ItemVariationSelection.vue?vue&type=script&lang=js"
export * from "./ItemVariationSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81da073e",
  null
  
)

export default component.exports